import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const CountriesContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  border-top: 1px solid ${Colors.GS400};

  ${mediaQueries.tablet} {
    height: 456px;
  }
`

export const CountryContainer = styled.label`
  padding: 16px 0;
  display: flex;
  align-items: center;
  cursor: pointer;

  & + & {
    border-top: 1px solid ${Colors.GS400};
  }
`

export const CountryCheckboxLabel = styled.div`
  margin-left: 8px;
`

export const EmptyMessageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
